import { render } from "./PhoneDownloadNotice.vue?vue&type=template&id=6d638421"
import script from "./PhoneDownloadNotice.vue?vue&type=script&lang=js"
export * from "./PhoneDownloadNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__